window.addEventListener("load", function(){
  hummAlt();
  uniqueID();
});


async function hummAlt() {
    await new Promise((resolve) =>
                    setTimeout(resolve, 1000))
    var humm = document.querySelectorAll('.flexifi-widget-logo');
    for (let i = 0; i < humm.length; i++) {
        //add alt text if missing (but title is present)
        humm[i].alt = "Humm Logo";
        humm[i].width= "81px";
        humm[i].height= "16px";
        humm[i].loading= "lazy";
    }
}

async function uniqueID () {
  await new Promise((resolve) =>
                    setTimeout(resolve, 1000))
  var newID = document.querySelectorAll('#flexifi-tag');
    for (let i = 0; i < newID.length; i++) {

        newID[i].id = "flexifi-tag"+[i] ;
    }
}

